import React, { useCallback, useState } from "react";
import { Button, Icon, ModalDialog, TextField, Success, PlainButton } from "@culturehq/components";

import { useProfile } from "app/context";
import { Trans } from "app/utils";
import ChqModalDialog from "components/common/ChqModalDialog";

const EMBBED_CODE = "<iframe src=\"https://SUBDOMAIN.culturehq.com\" frameborder=\"0\" style=\"width:100%; -ms-overflow-style: none; overflow: -moz-scrollbars-none; height:1000px\" scrolling=\"yes\" allowfullscreen></iframe>";

const replaceEmbbededCode = subdomain => EMBBED_CODE.replaceAll("SUBDOMAIN", subdomain);

const EmbedLandingPage = ({
  onClose: onCloseMenu
}) => {
  const { profile } = useProfile();
  const subdomain = profile.organization.name.replace(/\s+/g, "-").toLowerCase();
  const [copied, setCopied] = useState(false);
  const [open, setOpen] = useState(false);
  const embeddableCode = replaceEmbbededCode(subdomain);

  const onOpen = useCallback(() => setOpen(true), [setOpen]);
  const onClose = useCallback(
    () => {
      setCopied(false);
      setOpen(false);
      if (onCloseMenu) {
        onCloseMenu();
      }
    },
    [onCloseMenu, setCopied, setOpen]
  );

  const onCopy = useCallback(
    () => {
      document.querySelector("#embeddable_code").select();
      document.execCommand("copy");
      setCopied(true);
    },
    [setCopied]
  );

  return (
    <>
      <PlainButton onClick={onOpen}>
        <Icon icon="open-book" /><Trans>Landing Page</Trans>
      </PlainButton>
      {open && (
        <ChqModalDialog onClose={onClose} className="EmbedStories">
          <ModalDialog.Heading onClose={onClose}>
            <Trans>Embed Landing Page</Trans>
          </ModalDialog.Heading>
          <ModalDialog.Body>
            <TextField
              readOnly
              rows={3}
              name="embeddable_code"
              value={embeddableCode}
            />
            {copied && (
              <Success>
                <Trans>Embeddable code copied to the clipboard.</Trans>
              </Success>
            )}
            <div className="ButtonContainer">
              <Button icon="copy" primary onClick={onCopy}>
                <Trans>Copy Code</Trans>
              </Button>
            </div>
          </ModalDialog.Body>
        </ChqModalDialog>
      )}
    </>
  );
};

export default EmbedLandingPage;
